import { render, staticRenderFns } from "./15minutesindex.vue?vue&type=template&id=0afaf013&scoped=true&"
import script from "./15minutesindex.vue?vue&type=script&lang=js&"
export * from "./15minutesindex.vue?vue&type=script&lang=js&"
import style0 from "./15minutesindex.vue?vue&type=style&index=0&id=0afaf013&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afaf013",
  null
  
)

export default component.exports